/* DogSmile v10 · mise en scène — GSAP 3 (ScrollTrigger, SplitText), Lenis, pot 3D (three.js, chargé à la demande).
   Règle d'or mobile : sur écran tactile, AUCUNE animation n'est liée à la position du doigt (défilement 100 % natif,
   pas de Lenis, pas d'épinglage) — seulement des apparitions ponctuelles, une fois.
   Effets « React Bits » réécrits en JS natif : SpotlightCard, TiltedCard, GlareHover, Magnet (et ShinyText en CSS). */
(function () {
  'use strict';
  var w = window, d = document, html = d.documentElement;
  w.__x10 = true; // désactive le repli statique posé dans le <head>
  var mq = function (q) { return w.matchMedia(q).matches; };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  var DESK_Q = '(min-width: 900px) and (min-height: 700px) and (hover: hover) and (pointer: fine)';
  var desk = mq(DESK_Q);
  var editor = !!(w.Shopify && w.Shopify.designMode);
  var gsap = w.gsap, ST = w.ScrollTrigger, Split = w.SplitText || null;
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  /* ---------- Pot 3D : chaque module n'est chargé qu'une fois, après la page ---------- */
  var studioP = {}, studioN = 0;
  function getStudio(src) {
    if (!studioP[src]) {
      var ev = 'ds8:studio' + (studioN++);
      studioP[src] = new Promise(function (res) {
        w.addEventListener(ev, function (e) { res(e.detail); }, { once: true });
        var s = d.createElement('script');
        s.type = 'module';
        // La minification Shopify transforme import() en require() : on passe par un module injecté.
        s.textContent = 'import{create}from' + JSON.stringify(src) + ';window.dispatchEvent(new CustomEvent(' + JSON.stringify(ev) + ',{detail:create}));';
        d.head.appendChild(s);
      });
    }
    return studioP[src];
  }

  /* ---------- En-tête fixe : sa hauteur réelle sert de marge à tout ce qui défile ou colle en haut ---------- */
  var hdr = d.querySelector('.ds-header');
  function setHead() { if (hdr && hdr.offsetHeight) html.style.setProperty('--x-head', hdr.offsetHeight + 'px'); }
  function headOffset() { return (hdr && hdr.offsetHeight ? hdr.offsetHeight : 76) + 16; }
  setHead();
  if (hdr && w.ResizeObserver) new ResizeObserver(setHead).observe(hdr);
  function scrollToY(y) {
    if (lenis) { lenis.scrollTo(y, { duration: 0.9 }); return; }
    y = Math.max(0, Math.round(y));
    var y0 = w.scrollY, dy = y - y0;
    if (Math.abs(dy) < 2) return;
    if (reduce) { w.scrollTo({ top: y, behavior: 'instant' }); return; }
    // Défilement animé image par image : le défilement « smooth » natif est parfois annulé par le navigateur (téléphone)
    var t0 = 0, dur = Math.min(700, 260 + Math.abs(dy) * 0.4), stop = false;
    var off = function () { stop = true; };
    w.addEventListener('touchstart', off, { once: true, passive: true });
    w.addEventListener('wheel', off, { once: true, passive: true });
    var step = function (t) {
      if (stop) return;
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      w.scrollTo({ top: y0 + dy * (1 - Math.pow(1 - k, 3)), behavior: 'instant' });
      if (k < 1) w.requestAnimationFrame(step); else { w.removeEventListener('touchstart', off); w.removeEventListener('wheel', off); }
    };
    w.requestAnimationFrame(step);
  }
  /* Questionnaire : chaque nouvelle question arrive SOUS l'en-tête, jamais derrière (remplace le scrollIntoView de dogsmile.js) */
  qsa('[data-quiz]').forEach(function (root) {
    root.scrollIntoView = function () {
      var top = root.getBoundingClientRect().top;
      if (Math.abs(top - headOffset()) < 6) return;
      scrollToY(top + w.scrollY - headOffset());
    };
  });

  /* Pots 3D déjà affichés sur la page (hero, fiche produit) : mis en pause quand la fenêtre 3D est ouverte */
  var x3d = { open: false }, bg3d = [];
  var conn = navigator.connection || {};
  var lite = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '') || (navigator.deviceMemory && navigator.deviceMemory < 3);
  // Pas de contexte WebGL d'essai (coûteux sur téléphone) : create() est déjà protégé par try/catch.
  function can3d() { return !lite && !!w.WebGLRenderingContext; }
  function afterLoad(fn) {
    var go = function () { if (w.requestIdleCallback) { w.requestIdleCallback(fn, { timeout: 2000 }); } else { setTimeout(fn, 300); } };
    if (d.readyState === 'complete') go(); else w.addEventListener('load', go, { once: true });
  }

  /* ---------- Fiche produit : pot 3D interactif (fonctionne aussi sans animations) ---------- */
  var FRONT = 0.3;
  qsa('[data-pdp3d]').forEach(function (slide) {
    var cv = slide.querySelector('canvas'), btn = slide.querySelector('[data-pdp3d-toggle]'), src = slide.getAttribute('data-studio-src');
    if (!src || !cv) return;
    var ctrl = null, st = { p: 0 }, open = false, yaw = 0, x0 = 0, yaw0 = 0, drag = false;
    var clampYaw = function (v) { return Math.min(0.35, Math.max(-0.25, v)); };
    var goTo = function (p, dur) {
      if (!gsap || reduce) { st.p = p; if (ctrl) ctrl.setProgress(p); return; }
      gsap.to(st, { p: p, duration: dur, ease: 'power2.inOut', overwrite: true, onUpdate: function () { if (ctrl) ctrl.setProgress(st.p); } });
    };
    afterLoad(function () {
      if (!can3d()) return;
      getStudio(src).then(function (create) {
        try {
          ctrl = create(cv, {
            label: slide.getAttribute('data-label'), wipe: slide.getAttribute('data-wipe'),
            pixelRatio: Math.min(w.devicePixelRatio || 1, 2),
            onReady: function () { if (!ctrl) return; ctrl.setProgress(st.p); w.requestAnimationFrame(function () { slide.classList.add('is-3d'); goTo(open ? 0.96 : FRONT, 1.4); }); }
          });
        } catch (e) { ctrl = null; return; }
        ctrl.setProgress(0);
        var seen = true;
        bg3d.push({ c: ctrl, resume: function () { ctrl.setRunning(seen); } });
        if (w.ResizeObserver) new ResizeObserver(function () { ctrl.resize(); }).observe(cv);
        if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; ctrl.setRunning(seen && !x3d.open); }); }).observe(slide);
      });
    });
    if (fine) {
      cv.addEventListener('pointerdown', function (e) { if (!ctrl) return; drag = true; x0 = e.clientX; yaw0 = yaw; try { cv.setPointerCapture(e.pointerId); } catch (err) {} slide.classList.add('is-drag'); });
      cv.addEventListener('pointermove', function (e) { if (!drag || !ctrl) return; yaw = clampYaw(yaw0 + (e.clientX - x0) / Math.max(1, cv.clientWidth) * 1.4); ctrl.setYaw(yaw); });
      var end = function () { drag = false; slide.classList.remove('is-drag'); };
      cv.addEventListener('pointerup', end);
      cv.addEventListener('pointercancel', end);
    }
    qsa('[data-pdp3d-rot]', slide).forEach(function (b) {
      b.addEventListener('click', function () { if (!ctrl) return; yaw = clampYaw(yaw + 0.2 * (parseInt(b.getAttribute('data-pdp3d-rot'), 10) || 1)); ctrl.setYaw(yaw); });
    });
    if (btn) btn.addEventListener('click', function () { if (!ctrl) return; open = !open; btn.textContent = btn.getAttribute(open ? 'data-close' : 'data-open'); goTo(open ? 0.96 : FRONT, 1.8); });
  });

  /* ---------- Fenêtre « pot en 3D » : pivoter, incliner, zoomer, ouvrir ; repères reliés par des lignes ---------- */
  (function () {
    var dlg = d.querySelector('[data-x3d]');
    if (!dlg || typeof dlg.showModal !== 'function' || !can3d()) { html.classList.add('x-no3d'); return; }
    var box = dlg.querySelector('.x3d__box'), view = dlg.querySelector('[data-x3d-view]'), cv = dlg.querySelector('.x3d__canvas');
    var tog = dlg.querySelector('[data-x3d-toggle]'), topB = dlg.querySelector('[data-x3d-top]');
    var fx = !reduce && !!gsap;
    var keys = ['lid', 'body', 'label', 'wipe'], pins = {}, lines = {}, notes = {};
    keys.forEach(function (k) {
      pins[k] = dlg.querySelector('[data-pin="' + k + '"]');
      lines[k] = dlg.querySelector('[data-line="' + k + '"]');
      notes[k] = dlg.querySelector('[data-note="' + k + '"]');
    });
    var ctrl = null, st = { p: 0 }, opened = false, yaw = 0, pitch = 0, uz = 1, base = 1, shown = false, slots = null, opener = null;
    var clampYaw = function (v) { return Math.min(0.55, Math.max(-0.2, v)); };
    // Zoom = cadrage de base (fenêtre étroite : pot un peu plus petit pour laisser la place aux annotations)
    //        × recul quand le pot est ouvert (couvercle soulevé) × zoom choisi par le visiteur
    var applyZoom = function () { if (ctrl) ctrl.setZoom(Math.min(1.45, Math.max(0.8, base * (opened ? 0.9 : 1) * uz))); };
    // Emplacement des annotations (grand écran) : mesuré à l'ouverture et au redimensionnement, pas à chaque image
    var measure = function () {
      slots = null;
      base = 1;
      if (!w.matchMedia('(min-width: 900px)').matches) { applyZoom(); return; }
      base = Math.min(1, Math.max(0.8, view.clientWidth / Math.max(1, view.clientHeight) / 1.35));
      applyZoom();
      slots = {};
      var mid = view.clientWidth / 2;
      keys.forEach(function (k) {
        var n = notes[k];
        var left = n.offsetLeft + n.offsetWidth / 2 < mid;
        slots[k] = { x: left ? n.offsetLeft + n.offsetWidth : n.offsetLeft, y: n.offsetTop, dir: left ? 1 : -1 };
      });
    };
    var vis = function (k) { return shown && (k !== 'wipe' || st.p > 0.62); };
    var draw = function () {
      if (!ctrl) return;
      if (!shown && st.p > 0.28) shown = true; // repères visibles dès que le pot est de face
      var a = ctrl.anchors();
      keys.forEach(function (k) {
        var p = a[k], on = vis(k);
        if (!p) return;
        if (pins[k]) { pins[k].style.transform = 'translate(' + p.x.toFixed(1) + 'px,' + p.y.toFixed(1) + 'px)'; pins[k].classList.toggle('is-on', on); }
        if (notes[k]) { notes[k].classList.toggle('is-on', on); notes[k].classList.toggle('is-dim', !on); }
        if (slots && lines[k]) {
          var s = slots[k], ex = s.x + 32 * s.dir;
          lines[k].setAttribute('d', 'M' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + 'L' + ex.toFixed(1) + ' ' + s.y + 'L' + s.x + ' ' + s.y);
          lines[k].classList.toggle('is-on', on);
        }
      });
    };
    var goTo = function (p, dur, done) {
      if (!ctrl) return;
      if (!fx || !dur) { st.p = p; ctrl.setProgress(p); if (done) done(); return; }
      gsap.to(st, { p: p, duration: dur, ease: 'power2.inOut', overwrite: true, onUpdate: function () { ctrl.setProgress(st.p); }, onComplete: done });
    };
    var boot = function () {
      getStudio(dlg.getAttribute('data-studio-src')).then(function (create) {
        if (ctrl) return;
        try {
          ctrl = create(cv, {
            label: dlg.getAttribute('data-label'), wipe: dlg.getAttribute('data-wipe'),
            pixelRatio: Math.min(w.devicePixelRatio || 1, fine ? 2 : 1.75),
            onRender: draw,
            onReady: function () {
              dlg.classList.add('is-ready');
              measure();
              // Ouverture : le pot pivote vers sa face (ou s'ouvre directement si le visiteur l'a déjà demandé), puis les repères apparaissent
              goTo(opened ? 0.96 : 0.3, 1.6, function () { if (ctrl) ctrl.renderNow(); });
            }
          });
        } catch (e) { ctrl = null; dlg.classList.add('is-ready'); return; }
        ctrl.setProgress(0);
        ctrl.setRunning(x3d.open);
        if (w.ResizeObserver) new ResizeObserver(function () { if (ctrl && x3d.open) { ctrl.resize(); measure(); ctrl.renderNow(); } }).observe(view);
      });
    };
    var openX3d = function (from) {
      if (x3d.open) return;
      opener = from || d.activeElement;
      x3d.open = true;
      bg3d.forEach(function (b) { b.c.setRunning(false); });
      if (lenis) lenis.stop();
      html.classList.add('x3d-lock');
      dlg.showModal();
      measure();
      if (fx) gsap.fromTo(box, { opacity: 0, y: 28, scale: 0.985 }, { opacity: 1, y: 0, scale: 1, duration: 0.7, ease: 'expo.out', clearProps: 'transform,opacity' });
      if (ctrl) { ctrl.setRunning(true); ctrl.resize(); ctrl.renderNow(); } else boot();
    };
    var closeX3d = function () {
      if (!x3d.open || dlg.classList.contains('is-closing')) return;
      if (!fx) { dlg.close(); return; }
      dlg.classList.add('is-closing');
      gsap.to(box, { opacity: 0, y: 18, duration: 0.26, ease: 'power2.in', onComplete: function () { dlg.close(); } });
    };
    dlg.addEventListener('close', function () {
      x3d.open = false;
      dlg.classList.remove('is-closing');
      if (gsap) gsap.set(box, { clearProps: 'transform,opacity' });
      html.classList.remove('x3d-lock');
      if (lenis) lenis.start();
      if (ctrl) ctrl.setRunning(false);
      bg3d.forEach(function (b) { b.resume(); });
      if (opener && opener.focus && d.contains(opener)) opener.focus({ preventScroll: true });
    });
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closeX3d(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeX3d(); });
    qsa('[data-x3d-close]', dlg).forEach(function (b) { b.addEventListener('click', closeX3d); });

    // Commandes
    qsa('[data-x3d-rot]', dlg).forEach(function (b) {
      b.addEventListener('click', function () { if (!ctrl) return; yaw = clampYaw(yaw + 0.2 * (parseInt(b.getAttribute('data-x3d-rot'), 10) || 1)); ctrl.setYaw(yaw); });
    });
    qsa('[data-x3d-zoom]', dlg).forEach(function (b) {
      b.addEventListener('click', function () { uz = Math.min(1.3, Math.max(0.85, uz + 0.15 * (parseInt(b.getAttribute('data-x3d-zoom'), 10) || 1))); applyZoom(); });
    });
    var setTop = function (on) { pitch = on ? 0.5 : 0; if (topB) topB.setAttribute('aria-pressed', on ? 'true' : 'false'); if (ctrl) ctrl.setPitch(pitch); };
    if (topB) topB.addEventListener('click', function () { setTop(topB.getAttribute('aria-pressed') !== 'true'); });
    if (tog) tog.addEventListener('click', function () {
      opened = !opened;
      tog.classList.toggle('is-on', opened);
      tog.textContent = tog.getAttribute(opened ? 'data-close' : 'data-open');
      if (!ctrl || !dlg.classList.contains('is-ready')) return; // appliqué à l'apparition du pot
      applyZoom();
      goTo(opened ? 0.96 : 0.3, 1.8);
    });

    // Glisser : horizontal = pivoter (souris et doigt) ; vertical = incliner (souris ; au doigt, le défilement reste natif)
    var drag = null;
    view.addEventListener('pointerdown', function (e) {
      if (!ctrl || e.button > 0) return;
      drag = { x: e.clientX, y: e.clientY, yaw: yaw, pitch: pitch, id: e.pointerId, mouse: e.pointerType === 'mouse' };
      try { view.setPointerCapture(e.pointerId); } catch (err) {}
      view.classList.add('is-drag');
    });
    view.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      yaw = clampYaw(drag.yaw + (e.clientX - drag.x) / Math.max(1, view.clientWidth) * 1.6);
      ctrl.setYaw(yaw);
      if (drag.mouse) { pitch = Math.min(0.55, Math.max(-0.12, drag.pitch + (e.clientY - drag.y) / Math.max(1, view.clientHeight) * 1.2)); ctrl.setPitch(pitch); }
    });
    var endDrag = function () {
      if (!drag) return;
      drag = null;
      view.classList.remove('is-drag');
      if (topB) topB.setAttribute('aria-pressed', pitch > 0.3 ? 'true' : 'false');
    };
    view.addEventListener('pointerup', endDrag);
    view.addEventListener('pointercancel', endDrag);

    // Fiche produit : « Acheter » ferme la fenêtre et amène au choix de l'offre
    var buy = dlg.querySelector('[data-x3d-buy]'), form = d.querySelector('[data-ds-form]');
    if (buy && form) buy.addEventListener('click', function (e) {
      e.preventDefault();
      closeX3d();
      setTimeout(function () { scrollToY(form.getBoundingClientRect().top + w.scrollY - headOffset()); }, fx ? 320 : 0);
    });

    // Ouverture : boutons « Explorer en 3D », ou clic direct sur le pot (sans glisser)
    qsa('[data-x3d-open]').forEach(function (b) { b.addEventListener('click', function () { openX3d(b); }); });
    qsa('.x-hero__product, [data-pdp3d]').forEach(function (el) {
      var sx = 0, sy = 0, btn = el.querySelector('[data-x3d-open]');
      el.classList.add('has-x3d');
      el.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; }, { passive: true });
      el.addEventListener('click', function (e) {
        if (e.target.closest('button, a')) return;
        if (Math.abs(e.clientX - sx) + Math.abs(e.clientY - sy) > 8) return;
        openX3d(btn);
      });
    });
  })();

  /* ---------- Sans animations (préférence système, éditeur, scripts absents) : tout reste visible ---------- */
  function off() {
    html.classList.remove('x-motion', 'x-scrolly');
    qsa('.x-hero__t').forEach(function (h) { h.classList.add('is-go'); });
  }
  if (reduce || editor || !gsap || !ST) { off(); return; }
  gsap.registerPlugin(ST);
  if (Split) gsap.registerPlugin(Split);
  ST.config({ ignoreMobileResize: true });
  if (!desk) html.classList.remove('x-scrolly'); else html.classList.add('x-scrolly');
  // Passage ordinateur ↔ petite fenêtre : on recharge la mise en scène adaptée (cas rare : redimensionnement manuel).
  var deskMq = w.matchMedia(DESK_Q);
  var onMq = function () { if (deskMq.matches !== desk) w.location.reload(); };
  if (deskMq.addEventListener) deskMq.addEventListener('change', onMq); else if (deskMq.addListener) deskMq.addListener(onMq);

  /* 1. Défilement doux : souris uniquement. Le tactile garde le défilement natif du système. */
  var lenis = null, menu = d.querySelector('.ds-menu');
  if (w.Lenis && desk) {
    lenis = new w.Lenis({ autoRaf: false, lerp: 0.1 });
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    if (menu) menu.setAttribute('data-lenis-prevent', '');
    // Ancres internes : défilement doux ET focus déplacé sur la cible (le lien d'évitement reste natif)
    d.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || a.classList.contains('ds-skip') || e.defaultPrevented) return;
      var id = a.getAttribute('href').slice(1), t = id && d.getElementById(id);
      if (!t) return;
      e.preventDefault();
      lenis.scrollTo(t, { offset: -headOffset() });
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      t.focus({ preventScroll: true });
    });
    new MutationObserver(function () { if (d.body.classList.contains('ds-menu-open')) lenis.stop(); else lenis.start(); }).observe(d.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* Apparition ponctuelle (une fois) : transform + opacité uniquement */
  function revealOnce(targets, vars) {
    targets = targets.filter(Boolean);
    if (!targets.length) return;
    vars = vars || {};
    gsap.set(targets, { opacity: 0, y: vars.y == null ? 40 : vars.y });
    ST.batch(targets, {
      start: vars.start || 'top 88%', once: true,
      onEnter: function (els) { gsap.to(els, { opacity: 1, y: 0, duration: vars.duration || 1.1, ease: 'expo.out', stagger: vars.stagger || 0.09, overwrite: true }); }
    });
  }
  function splitLines(el, build) {
    if (!Split) return false;
    Split.create(el, { type: 'lines', mask: 'lines', linesClass: 'x-line', autoSplit: true, ignore: 'svg', onSplit: function (self) { return build(self); } });
    return true;
  }
  function drawPath(path, vars) {
    if (!path) return null;
    var len = 420;
    try { len = path.getTotalLength(); } catch (e) {}
    gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
    return gsap.to(path, Object.assign({ strokeDashoffset: 0, duration: 1.2, ease: 'power2.inOut' }, vars || {}));
  }
  /* Économie d'énergie : animations CSS en pause hors écran */
  function pauseOffscreen(el) {
    if (!('IntersectionObserver' in w) || !el) return;
    new IntersectionObserver(function (es) { es.forEach(function (e) { el.classList.toggle('is-paused', !e.isIntersecting); }); }, { rootMargin: '120px 0px' }).observe(el);
  }

  /* 2. Titres de section : lignes révélées par masque, une fois */
  qsa('.x-sec-head .x-h2').forEach(function (h) {
    var head = h.closest('.x-sec-head--split') || h.closest('.x-sec-head');
    var ok = splitLines(h, function (self) {
      return gsap.from(self.lines, { yPercent: 118, duration: 1.25, ease: 'expo.out', stagger: 0.09, scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    });
    var extra = qsa('.x-kicker, .x-lead', head);
    if (extra.length) gsap.from(extra, { y: 18, opacity: 0, duration: 1, ease: 'power3.out', stagger: 0.08, scrollTrigger: { trigger: h, start: 'top 88%', once: true } });
    if (!ok) revealOnce([h]);
  });

  /* 3. Hero */
  var hero = d.querySelector('[data-x-hero]');
  if (hero) { try { buildHero(hero); } catch (err) { off(); } }

  function heroIntro(sec) {
    var h1 = sec.querySelector('.x-hero__t'), intro = sec.querySelector('.x-hero__intro'), prod = sec.querySelector('.x-hero__product');
    var bits = qsa('.x-kicker, .x-lead, .x-ctas, .x-trust', intro);
    var inner = sec.querySelector('.x-hero__inner') || prod;
    var tl = gsap.timeline({ delay: 0.05 });
    if (inner) tl.from(inner, { opacity: 0, scale: 0.9, duration: 1.6, ease: 'expo.out' }, 0);
    tl.from(bits, { y: 24, opacity: 0, duration: 1, ease: 'power3.out', stagger: 0.08 }, 0.35);
    var ring = sec.querySelector('.x-hero__ring path');
    if (ring) tl.add(drawPath(ring, { duration: 1.6 }), 0.4);
    if (!h1) return;
    var smile = h1.querySelector('.x-smile path');
    var split = splitLines(h1, function (self) {
      h1.classList.add('is-go');
      var t = gsap.timeline({ delay: 0.1 });
      t.from(self.lines, { yPercent: 120, duration: 1.35, ease: 'expo.out', stagger: 0.12 }, 0);
      if (smile) t.fromTo(smile.parentNode, { scaleX: 0 }, { scaleX: 1, duration: 1, ease: 'power3.inOut' }, 0.75);
      return t;
    });
    if (!split) { h1.classList.add('is-go'); if (smile) gsap.fromTo(smile.parentNode, { scaleX: 0 }, { scaleX: 1, duration: 1, delay: 0.6, ease: 'power3.inOut' }); }
  }

  var idleOk = true;
  function load3d(sec, box, canvas, opts) {
    var src = sec.getAttribute('data-studio-src');
    if (!src || !canvas || !box) return;
    afterLoad(function () {
      if (!can3d()) return;
      getStudio(src).then(function (create) {
        var ctrl;
        try {
          ctrl = create(canvas, {
            label: opts.label, wipe: sec.getAttribute('data-wipe'), idle: true, idleFps: opts.idleFps,
            pixelRatio: Math.min(w.devicePixelRatio || 1, opts.maxDpr),
            onReady: function () { w.requestAnimationFrame(function () { box.classList.add('is-3d'); }); }
          });
        } catch (e) { return; }
        opts.bind(ctrl);
        // Mouvement au repos limité dans le temps (WCAG 2.2.2) : 12 s, puis le pot reste posé.
        setTimeout(function () { idleOk = false; ctrl.setIdle(false); }, 12000);
        if (w.ResizeObserver) new ResizeObserver(function () { ctrl.resize(); }).observe(canvas); else w.addEventListener('resize', ctrl.resize);
      });
    });
  }

  function buildHero(sec) {
    var stage = sec.querySelector('.x-hero__stage'), prod = sec.querySelector('.x-hero__product'), canvas = sec.querySelector('.x-hero__canvas');
    var intro = sec.querySelector('.x-hero__intro'), caps = qsa('.x-cap', sec);
    heroIntro(sec);
    pauseOffscreen(sec);

    if (!desk) {
      // Téléphone : pot 3D vivant (balancement au repos), mis en pause pendant le défilement et hors écran.
      revealOnce(caps, { y: 30 });
      var visible = true, scrolling = false, tmr = 0, c3 = null;
      var apply = function () { if (c3) c3.setRunning(visible && !scrolling && !x3d.open); };
      var lab = (sec.getAttribute('data-label') || '').replace('width=2048', 'width=1024');
      load3d(sec, prod, canvas, {
        maxDpr: 1.5, idleFps: 30, label: lab,
        bind: function (ctrl) {
          c3 = ctrl; ctrl.setProgress(0.3); apply();
          bg3d.push({ c: ctrl, resume: apply });
          if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; apply(); }); }).observe(prod);
          var busy = function () { if (!scrolling) { scrolling = true; apply(); } clearTimeout(tmr); tmr = setTimeout(function () { scrolling = false; apply(); }, 160); };
          w.addEventListener('scroll', busy, { passive: true });
          w.addEventListener('touchstart', busy, { passive: true });
        }
      });
      return;
    }

    // Ordinateur : scène collante pilotée par le défilement.
    var bar = sec.querySelector('.x-hud__bar i'), dots = qsa('.x-hud__dots li', sec), count = sec.querySelector('[data-x-count]');
    var hint = sec.querySelector('.x-hero__hint');
    var win = [0.16, 0.43, 0.7];
    var winEnd = function (i) { return i < caps.length - 1 ? win[i + 1] - 0.05 : 1.01; };
    var map3d = function (p) { return Math.min(1, Math.max(0, (p - 0.1) / 0.8)); };
    var ctrl = null, prog = 0, curStep = -2;

    // La 3D suit exactement la même timeline que le décor (rendu dans la même image, pas de décalage).
    var tl = gsap.timeline({ defaults: { ease: 'none' }, onUpdate: function () { sync3d(tl.progress()); }, scrollTrigger: { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.3, invalidateOnRefresh: true } });
    if (bar) tl.to(bar, { scaleX: 1, duration: 1 }, 0);
    if (hint) tl.to(hint, { opacity: 0, duration: 0.04 }, 0.01);
    // Le texte reste à gauche (les étapes remplacent l'accroche), le pot reste à droite : seulement une respiration d'échelle
    tl.to(intro, { opacity: 0, y: -50, duration: 0.09, ease: 'power2.in' }, 0.04);
    tl.to(prod, { scale: 1.05, duration: 0.3, ease: 'power1.inOut' }, 0.08)
      .to(prod, { scale: 1, duration: 0.3, ease: 'power1.inOut' }, 0.5)
      .to(prod, { y: function () { return -w.innerHeight * 0.03; }, scale: 0.92, duration: 0.12, ease: 'power1.in' }, 0.88);
    caps.forEach(function (c, i) {
      var t = c.querySelector('.x-cap__t'), rest = qsa('.x-cap__n, p, .x-btn', c);
      tl.fromTo(c, { opacity: 0 }, { opacity: 1, duration: 0.04 }, win[i]);
      if (t) tl.fromTo(t, { y: 60, opacity: 0 }, { y: 0, opacity: 1, duration: 0.07, ease: 'power3.out' }, win[i]);
      if (rest.length) tl.fromTo(rest, { y: 30, opacity: 0 }, { y: 0, opacity: 1, duration: 0.07, stagger: 0.01, ease: 'power3.out' }, win[i] + 0.02);
      if (i < caps.length - 1) tl.to(c, { opacity: 0, y: -40, duration: 0.05, ease: 'power2.in' }, win[i + 1] - 0.06);
    });

    var setOn = function (p) {
      intro.classList.toggle('x-intro-off', p > 0.08);
      var step = -1;
      caps.forEach(function (c, i) { c.classList.toggle('is-on', p >= win[i] && p < winEnd(i)); if (p >= win[i]) step = i; });
      if (step !== curStep) {
        curStep = step;
        dots.forEach(function (dt, i) { dt.classList.toggle('is-on', i === Math.max(0, step)); });
        if (count) count.textContent = '0' + (step + 1);
      }
    };
    var sync3d = function (p) { if (!ctrl) return; ctrl.setProgress(map3d(p)); ctrl.setIdle(idleOk && p < 0.03); ctrl.renderNow(); };
    setOn(0);
    ST.create({ trigger: sec, start: 'top top', end: 'bottom bottom', onUpdate: function (self) { prog = self.progress; setOn(prog); } });

    // Clavier : un élément qui reçoit le focus est toujours amené à l'écran (WCAG 2.4.7 / 2.4.11)
    var scrollToP = function (p) {
      var y = sec.getBoundingClientRect().top + w.scrollY + p * (sec.offsetHeight - w.innerHeight);
      if (lenis) lenis.scrollTo(y, { immediate: true }); else w.scrollTo(0, y);
    };
    sec.addEventListener('focusin', function (e) {
      var t = e.target;
      if (intro.contains(t)) { if (prog > 0.03) scrollToP(0); return; }
      caps.forEach(function (c, i) { if (c.contains(t) && (prog < win[i] + 0.08 || prog > winEnd(i) - 0.02)) scrollToP(Math.min(win[i] + 0.1, 0.97)); });
    });

    load3d(sec, prod, canvas, {
      maxDpr: 1.5, label: sec.getAttribute('data-label'),
      bind: function (c) {
        ctrl = c; setOn(prog); sync3d(tl.progress());
        var seen = true;
        bg3d.push({ c: c, resume: function () { c.setRunning(seen); } });
        if ('IntersectionObserver' in w) new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; ctrl.setRunning(seen && !x3d.open); }); }).observe(stage);
        stage.addEventListener('pointermove', function (e) { ctrl.setPointer((e.clientX / w.innerWidth) * 2 - 1, (e.clientY / w.innerHeight) * 2 - 1); }, { passive: true });
      }
    });
  }

  /* 4. La méthode : défilement horizontal épinglé (ordinateur) / cartes empilées natives (téléphone) */
  qsa('[data-x-method]').forEach(function (sec) {
    var steps = qsa('.x-step', sec);
    if (!desk) {
      steps.forEach(function (st) {
        var img = st.querySelector('.x-step__media img');
        if (img) gsap.from(img, { scale: 1.12, opacity: 0, duration: 1.3, ease: 'expo.out', scrollTrigger: { trigger: st, start: 'top 85%', once: true } });
      });
      return;
    }
    sec.classList.add('is-h');
    var row = sec.querySelector('.x-method__row'), pin = sec.querySelector('.x-method__pin');
    var dist = function () { return Math.max(0, row.scrollWidth - w.innerWidth); };
    var tween = gsap.to(row, { x: function () { return -dist(); }, ease: 'none', scrollTrigger: { trigger: pin, pin: pin, start: 'top top', end: function () { return '+=' + dist(); }, scrub: 0.3, invalidateOnRefresh: true } });
    steps.forEach(function (st) {
      var m = st.querySelector('.x-step__media'), img = m && m.querySelector('img'), body = st.querySelector('.x-step__body');
      if (m) gsap.fromTo(m, { clipPath: 'inset(14% 12% 14% 12%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', scrollTrigger: { trigger: st, containerAnimation: tween, start: 'left 95%', end: 'left 45%', scrub: true } });
      if (img) gsap.fromTo(img, { scale: 1.2 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: st, containerAnimation: tween, start: 'left right', end: 'right left', scrub: true } });
      if (body) gsap.from(body, { y: 50, opacity: 0, ease: 'power2.out', scrollTrigger: { trigger: st, containerAnimation: tween, start: 'left 80%', end: 'left 50%', scrub: true } });
    });
  });

  /* 5. Offres, accessoires, engagements : apparitions + effets au survol (souris) */
  revealOnce(qsa('.x-plan'), { y: 70, stagger: 0.12 });
  revealOnce(qsa('.x-offers__note, .x-quiz'), { y: 20 });
  revealOnce(qsa('.x-acc'), { y: 60, stagger: 0.1 });
  revealOnce(qsa('.x-t'), { y: 40, stagger: 0.08 });
  revealOnce(qsa('.x-faq__list details'), { y: 24, stagger: 0.05 });
  qsa('.x-offers, .x-end, .x-accs').forEach(pauseOffscreen);

  if (fine) {
    // SpotlightCard : halo qui suit la souris
    qsa('[data-x-spot]').forEach(function (c) {
      var tgt = c.querySelector('.x-plan__spot') || c, r = null;
      c.addEventListener('pointerenter', function () { r = c.getBoundingClientRect(); }, { passive: true });
      c.addEventListener('pointermove', function (e) { if (!r) r = c.getBoundingClientRect(); tgt.style.setProperty('--mx', (e.clientX - r.left) + 'px'); tgt.style.setProperty('--my', (e.clientY - r.top) + 'px'); }, { passive: true });
    });
    // Profondeur du visuel des offres (TiltedCard)
    qsa('[data-x-depth]').forEach(function (v) {
      gsap.set(v, { transformPerspective: 900 });
      var rx = gsap.quickTo(v, 'rotationX', { duration: 0.8, ease: 'power3' }), ry = gsap.quickTo(v, 'rotationY', { duration: 0.8, ease: 'power3' });
      var card = v.closest('.x-plan') || v, cr = null;
      card.addEventListener('pointerenter', function () { cr = card.getBoundingClientRect(); });
      card.addEventListener('pointermove', function (e) { var r = cr || (cr = card.getBoundingClientRect()); ry(((e.clientX - r.left) / r.width - 0.5) * 16); rx(-((e.clientY - r.top) / r.height - 0.5) * 12); });
      card.addEventListener('pointerleave', function () { rx(0); ry(0); });
    });
    // Cartes accessoires inclinables + reflet (TiltedCard + GlareHover)
    qsa('[data-x-tilt]').forEach(function (a) {
      var card = a.querySelector('[data-x-tilt-card]') || a;
      var rx = gsap.quickTo(card, 'rotationX', { duration: 0.6, ease: 'power3' }), ry = gsap.quickTo(card, 'rotationY', { duration: 0.6, ease: 'power3' }), sc = gsap.quickTo(card, 'scale', { duration: 0.6, ease: 'power3' });
      var ar = null;
      a.addEventListener('pointerenter', function () { ar = a.getBoundingClientRect(); });
      a.addEventListener('pointermove', function (e) { var r = ar || (ar = a.getBoundingClientRect()); ry(((e.clientX - r.left) / r.width - 0.5) * 12); rx(-((e.clientY - r.top) / r.height - 0.5) * 12); sc(1.02); });
      a.addEventListener('pointerleave', function () { rx(0); ry(0); sc(1); });
    });
    // Magnet : boutons aimantés
    qsa('[data-x-mag]').forEach(function (b) {
      var xTo = gsap.quickTo(b, 'x', { duration: 0.6, ease: 'power3' }), yTo = gsap.quickTo(b, 'y', { duration: 0.6, ease: 'power3' });
      var br = null;
      b.addEventListener('pointerenter', function () { br = b.getBoundingClientRect(); });
      b.addEventListener('pointermove', function (e) { var r = br || (br = b.getBoundingClientRect()); xTo((e.clientX - r.left - r.width / 2) * 0.22); yTo((e.clientY - r.top - r.height / 2) * 0.32); });
      b.addEventListener('pointerleave', function () { xTo(0); yTo(0); });
    });
  }

  /* 6. FAQ : ouverture / fermeture en douceur (le contenu reste un <details> natif) */
  qsa('[data-x-faq] details').forEach(function (det) {
    var sum = det.querySelector('summary'), body = det.querySelector('.x-faq__a');
    if (!sum || !body) return;
    var closing = false;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      gsap.killTweensOf(body);
      if (det.open && !closing) {
        closing = true;
        gsap.fromTo(body, { height: body.offsetHeight, opacity: 1 }, { height: 0, opacity: 0, duration: 0.45, ease: 'power3.inOut', onComplete: function () { closing = false; det.open = false; gsap.set(body, { clearProps: 'height,opacity' }); } });
      } else {
        closing = false;
        det.open = true;
        gsap.fromTo(body, { height: 0, opacity: 0 }, { height: body.scrollHeight, opacity: 1, duration: 0.55, ease: 'power3.out', onComplete: function () { gsap.set(body, { clearProps: 'height,opacity' }); } });
      }
    });
  });

  /* 7. Conclusion : les mots s'allument (ordinateur : au défilement ; téléphone : une fois) */
  qsa('[data-x-end]').forEach(function (sec) {
    var t = sec.querySelector('.x-end__t'), mark = sec.querySelector('.x-end__mark'), smile = t && t.querySelector('.x-smile path');
    if (t && Split) {
      var sp = Split.create(t, { type: 'words', tag: 'span', aria: 'none', wordsClass: 'x-w', ignore: 'svg' });
      gsap.fromTo(sp.words, { opacity: 0.14 }, { opacity: 1, duration: 0.6, ease: 'power1.out', stagger: 0.08, scrollTrigger: { trigger: t, start: 'top 80%', once: true } });
    }
    if (smile) gsap.fromTo(smile.parentNode, { scaleX: 0 }, { scaleX: 1, duration: 1.1, ease: 'power3.inOut', scrollTrigger: { trigger: t, start: 'top 70%', once: true } });
    if (mark) gsap.from(mark, { scale: 0.4, opacity: 0, rotation: -20, duration: 1.2, ease: 'back.out(1.8)', scrollTrigger: { trigger: mark, start: 'top 85%', once: true } });
    revealOnce(qsa('.x-end__sig, .x-btn, .x-trust', sec), { y: 24 });
  });

  /* 8. En-tête : verre foncé au-dessus des sections sombres (simple bascule, aucun calcul continu) */
  var header = d.querySelector('.ds-header');
  if (header) {
    var active = 0;
    qsa('[data-tone="dark"], .ds-footer').forEach(function (s) {
      ST.create({ trigger: s, start: 'top 44px', end: 'bottom 44px', onToggle: function (self) { active += self.isActive ? 1 : -1; header.classList.toggle('x-on-dark', active > 0); } });
    });
  }

  /* 9. Menu mobile : liens en cascade */
  if (menu) new MutationObserver(function () {
    if (menu.classList.contains('is-open')) gsap.fromTo(qsa('a', menu), { y: 26, opacity: 0 }, { y: 0, opacity: 1, duration: 0.7, ease: 'expo.out', stagger: 0.05, delay: 0.1 });
  }).observe(menu, { attributes: true, attributeFilter: ['class'] });

  /* Les polices et images changent la mise en page : recalcul une fois tout chargé */
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { ST.refresh(); });
  w.addEventListener('load', function () { ST.refresh(); }, { once: true });
})();
